import * as React from 'react'

import { Box } from '@factorialco/deprecated-design-system'

import { observer } from 'mobx-react'

import FormRow from 'modules/core/components/FormRow'
import Select from 'modules/core/components/Inputs/Select'
import Text from 'modules/core/components/Inputs/Text'
import TogglerCheckbox from 'modules/core/components/Inputs/TogglerCheckbox'
import i18n from 'modules/core/lib/i18n'

import type ArgumentForm from 'modules/reports/components/Editor/Field/Options/Types/Filtering/ArgumentForm'
import type { OperatorForm } from 'modules/reports/components/Editor/Field/Options/Types/Filtering/forms'
import TeamPicker from 'modules/reports/components/TeamPicker'
import { OPERATORS } from 'modules/reports/lib/Constants'
import { VARIABLE_TYPES } from 'modules/reports/store/models/Dashboard'

interface FieldProps {
  operatorForm: OperatorForm
  form: ArgumentForm
  variableOptions: any[]
}

const Field = observer(({ operatorForm, form, variableOptions }: FieldProps) => {
  const useVariable = !!form.get('use_variable').value
  const label = i18n.t('custom_reports.especial_filters.employee_team.label')

  if (
    operatorForm.get('value').value === OPERATORS.starts_with ||
    operatorForm.get('value').value === OPERATORS.contains
  ) {
    return (
      <FormRow>
        <Text
          label={i18n.t('custom_reports.filter_arguments_labels.value')}
          field={form.get('value')}
        />
      </FormRow>
    )
  }

  return (
    <>
      {!useVariable && <TeamPicker label={label} field={form.get('value')} />}
      {useVariable && (
        <Select
          none={i18n.t('custom_reports.fields.filter_condition_none')}
          label={label}
          field={form.get('value')}
          options={variableOptions}
        />
      )}
      {!!variableOptions.length && (
        <TogglerCheckbox
          label={i18n.t('custom_reports.use_dashboard_filters')}
          field={form.get('use_variable')}
        />
      )}
    </>
  )
})
interface Props {
  forms: ArgumentForm[]
  variables: Array<{
    name: string
    type: any
  }>
  operatorForm: OperatorForm
}

const TeamSelector = ({ forms, variables, operatorForm }: Props) => {
  const form: ArgumentForm | undefined = forms[0]

  const variableOptions = variables
    .filter((variable) => variable.type === VARIABLE_TYPES.team)
    .map((variable) => ({
      label: variable.name,
      value: variable.name,
    }))

  return form ? (
    <Box
      flexDirection="column"
      gap="s8"
      background="grey200"
      padding="s24"
      borderRadius={{
        all: 'abs008',
      }}
    >
      <Field operatorForm={operatorForm} form={form} variableOptions={variableOptions} />
    </Box>
  ) : null
}

export default observer(TeamSelector)
